$("#home-slider").flexslider({
	animation: "slide",
	controlNav: false,
	controlsContainer: $(".custom-controls-container"),
	customDirectionNav: $(".custom-navigation a"),
});

$("#intro-slider").flexslider({
	animation: "slide",
	controlNav: false,
	controlsContainer: $(".custom-controls-container1"),
	customDirectionNav: $(".custom-navigation1 a"),
});

$("#product-slider").flexslider({
	animation: "slide",
	controlNav: false,
	controlsContainer: $(".custom-controls-container2"),
	customDirectionNav: $(".custom-navigation2 a"),
});

$("#culture-slider").flexslider({
	animation: "slide",
	controlNav: false,
	controlsContainer: $(".custom-controls-container3"),
	customDirectionNav: $(".custom-navigation3 a"),
});
